import  { useState, Fragment, useEffect } from "react";

import { IconButton, CircularProgress } from "@mui/material";

import FleetWebApi from "../Api/FleetWebApi";
import CloseIcon from "@mui/icons-material/Close";

import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import ErrorIcon from "@mui/icons-material/Error";
import AddIcon from "@mui/icons-material/Add"
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { useNavigate } from 'react-router-dom';
import { useAuthDataContext, UserRoles } from '../AuthDataProvider';



function AddUser() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("@alertlabs.com");
  const [userId, setUserId] = useState<string | null>(null);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [error, setError] = useState<null | string>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };


  const handleComplete = () => {
    setIsLoading(true);
    FleetWebApi.addUser(
      email
    ).then(
      result => {
        if (result.result === true) {
          setUserId(result.response)
          setIsLoading(false);
          setIsSuccess(true);
        } else {
          setSnackbarOpen(true);
          setIsLoading(false);
          setError("An unknown error occured");
        }
      }
    ).catch(error => {
      setSnackbarOpen(true);
      setIsLoading(false);
      setError(error.message);
    })
  };
  useEffect(()=>{
    if (isSuccess){
      navigate("/user/" + userId);
    }

  },[isSuccess, navigate]);

  const { user } = useAuthDataContext();
  if (user?.roles.includes(UserRoles.admin)) {

    if (userId === null) {

      return (

        <Fragment>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left"
            }}
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
          >
            <SnackbarContent
              className="errorSnackbar"
              message={
                <span id="message-id" className="snackbarMessage">
                  <ErrorIcon className="snackbarIcon" />
                  {error}
                </span>
              }
              action={[
                <IconButton
                  key="close"
                  aria-label="close"
                  color="inherit"
                  onClick={handleSnackbarClose}
                >
                  <CloseIcon />
                </IconButton>
              ]}
            />
          </Snackbar>

          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleDialogOpen}
            >
              <AddIcon />
            </IconButton>
          )}

          <Dialog
            open={isDialogOpen}
            onClose={handleDialogClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Add User
            </DialogTitle>
            <DialogContent>
              <DialogContentText>Add User E-mail</DialogContentText>
              <TextField
                id="email"
                label="E-Mail"
                value={email}
                onChange={e => setEmail(e.target.value)}
                margin="normal"
                fullWidth={true}
              />

            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleDialogClose}
                color="primary"
                variant="contained"
              >
                Cancel
              </Button>
              <div className="buttonWrapper">
                <Button
                  onClick={handleComplete}
                  color="primary"
                  variant="contained"
                  disabled={isLoading}
                  className={isSuccess ? "buttonSuccess" : ""}
                >
                  {isSuccess ? "Close" : "Create"}
                </Button>
                {isLoading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
              </div>
            </DialogActions>
          </Dialog>
        </Fragment>
      );
    } else {
      return null
    }
  } else {
    return (null)
  }

}

export default AddUser;
